 
import FAQ from "../components/FAQ";
 
function FaqPage() {
  return (
    <div>
       <section id="Contato" className="scroll-mt-[60px] md:scroll-mt-[100px] lg:scroll-mt-[120px]"><FAQ /></section>       
     </div>
  );
}

export default FaqPage;
